import { createSecureChannel } from '../abc/securechannel';
import {
    delegateRlp,
    getEncryptPlain,
    getGasData,
    getNetworkNonce,
    sign,
    signHash,
    signTypedData,
} from '../abc/transactions';
import { ethers } from 'ethers';
import { AbcWalletResult, Eip1559Result } from '../../index';
import { hashSign } from '../../../../services/abcWaas/transaction';
import { createCompactSignature } from './signature';

export const getSenderSignatureHex = async (txData: any) => {
    const wallet: AbcWalletResult = JSON.parse(window.sessionStorage.getItem('abcWallet') || '{}');

    // TODO : secure channel can be expired. So refresh it before each tx.
    await createSecureChannel();

    const secureChannel = JSON.parse(window.sessionStorage.getItem('secureChannel') || '{}');
    console.log('!!! secure channel : ', secureChannel);

    const encryptDevicePassword = await getEncryptPlain(wallet.encryptDevicePassword);
    const pvencstr = await getEncryptPlain(wallet.pvencstr);
    const wid = await getEncryptPlain(wallet.wid.toString());
    console.log('### encryptDevicePassword : ', encryptDevicePassword);
    console.log('### pvencstr : ', pvencstr.length);
    console.log('### wid : ', wid);

    try {
        const rlpHash = await delegateRlp({
            signer: 'sender',
            ...txData,
        });

        console.log('### sign : ', {
            encryptDevicePassword,
            pvencstr,
            uid: wallet.uid,
            wid,
            sid: wallet.sid,
            hash: rlpHash,
        });
        // Via backend
        const senderSignatureHex = await hashSign(
            {
                encryptDevicePassword,
                pvencstr,
                uid: wallet.uid,
                wid,
                sid: wallet.sid,
                hash: rlpHash,
            },
            secureChannel.ChannelID,
        );
        // Directly
        // const senderSignatureHex = await signHash({
        //     encryptDevicePassword,
        //     pvencstr,
        //     uid: wallet.uid,
        //     wid,
        //     sid: wallet.sid,
        //     hash: rlpHash,
        // });
        console.log('### senderSignatureHex : ', senderSignatureHex);

        let compact = '';
        if (senderSignatureHex) {
            const sigJson = JSON.parse(senderSignatureHex);
            const { r, s, vsource } = sigJson.sig_list[0];
            console.log('>>>>>>', { r, s, vsource });
            compact = createCompactSignature(r, s, vsource);
            console.log('### senderSignatureHex : ', compact);
        }
        return compact;
    } catch (err: any) {
        console.error(err?.message);
    }
};
